import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const BVMOptimizationsUI = (props: UIProperties<BVMOptimizationsUIConfig>) => {
	const [isOneHanded, setIsOneHanded] = useState(true);
	const [isOPA, setIsOPA] = useState(true);
	const [isNPA, setIsNPA] = useState(false);
	const [isManipulateHeadAndNeck, setIsManipulateHeadAndNeck] = useState(false);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '870px',
				height: '680px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '870px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='bvm-optimizations-top'>BVM Optimizations</p>
				</div>
				<div style={{
					width: '100%',
					height: '610px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					
					<CustomBVMOptimizationsButton 
						showYellowThingyOnTheSide={isOneHanded}
						ariaLbl= 'One Handed'
						width= '140px'
						text='One Handed'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '77px',
							left: '210px'
						}}
						onClicked={() => {
							setIsOneHanded(true);
						}}/>
					<CustomBVMOptimizationsButton 
						showYellowThingyOnTheSide={!isOneHanded}
						width= '140px'
						text='Two Handed'
						ariaLbl= 'Two Handed'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '77px',
							left: '520px'
						}}
						onClicked={() => {
							setIsOneHanded(false);
						}}/>

					<CustomBVMOptimizationsButton 
						showYellowThingyOnTheSide={isOPA}
						width= '140px'
						text='OPA'
						ariaLbl= 'OPA'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '230px',
							left: '110px'
						}}
						onClicked={() => {
							setIsOPA(!isOPA);
						}}/>
					<CustomBVMOptimizationsButton 
						showYellowThingyOnTheSide={isNPA}
						width= '140px'
						text='NPA'
						ariaLbl= 'NPA'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '230px',
							left: '370px'
						}}
						onClicked={() => {
							setIsNPA(!isNPA);
						}}/>
					<CustomBVMOptimizationsButton 
						ariaLbl= 'Manipulate Head and Neck'
						showYellowThingyOnTheSide={isManipulateHeadAndNeck}
						width= '140px'
						text='Manipulate Head &amp; Neck'
						textStyle={{
							fontSize: '12pt'
						}}
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '230px',
							left: '610px'
						}}
						onClicked={() => {
							setIsManipulateHeadAndNeck(!isManipulateHeadAndNeck);
						}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Make Attempt',
						ariaLbl: 'make attempt',
						top: '350px',
						left: '340px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.onMakeAttemptClicked(isOneHanded, isOPA, isNPA, isManipulateHeadAndNeck);
						}
					}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Choose Another Technique',
						ariaLbl: 'Choose Another Technique',
						id:'bvm-optimizations-bottom',
						top: '460px',
						left: '309px',
						width: '260px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%',
							height: '103px'
						},
						customButtonStyle : {
							width: '100%',
							height: '103px'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.onChooseAnotherTechniqueClicked();
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomBVMOptimizationsButton = (props: CustomBVMOptimizationsButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					ariaLbl: props.ariaLbl,
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large-1.png',
					customMainStyle: {
						position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'absolute',
					height: '100%',
					pointerEvents: 'none',
					width: '100%',
					left: '0',
					top: '0'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						left: '50%',
						width: '70%',
						transform: 'translate(-50%, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '18pt',
							fontWeight: 'normal',
							...props.textStyle
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: 0,
						right: '-21px',
						width: '28px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomBVMOptimizationsButtonConfig {
	text: string;
	textStyle?: any;
	ariaLbl?: string;
	width: string;
	position: CustomBVMOptimizationsPosition;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked: () => void;
}

interface CustomBVMOptimizationsPosition {
	type?: any;
	left: string;
	top: string;
}

export interface BVMOptimizationsUIConfig extends BaseConfig{
	onMakeAttemptClicked: (isOneHanded: boolean, isOPA: boolean, isNPA: boolean, isManipulateHeadAndNeck: boolean) => void;
	onChooseAnotherTechniqueClicked: () => void;
}

export default BVMOptimizationsUI;